import {
  select, call, put, takeEvery,
} from 'redux-saga/effects';
import api from 'linkia-api';

import {
  LIST,
  GET,
  UPDATE,
  REMOVE,
  CREATE,
} from './action-types';
import {
  list,
  reset,
  requestFailed,
  listSucceeded,
  getSucceeded,
  updateSucceeded,
  removeSucceeded,
  createSucceeded,
} from './actions';

import { tokenSelector } from '../login/selectors';

function* listCourseCategories() {
  const token = yield select(tokenSelector);
  try {
    const data = yield call(api.courseCategory.getAll, { token });
    yield put(listSucceeded(data));
  } catch (e) {
    yield put(requestFailed(e));
  }
}

function* getCourseCategory(action) {
  const token = yield select(tokenSelector);
  const { id } = action;
  try {
    const data = yield call(api.courseCategory.get, { token, id });
    yield put(getSucceeded(data));
  } catch (e) {
    yield put(requestFailed(e));
  }
}

function* updateCourseCategory(action) {
  const token = yield select(tokenSelector);
  const { id, data } = action;
  try {
    const success = yield call(api.courseCategory.update, { token, id, data });
    yield put(updateSucceeded(success));
    yield put(list());
  } catch (e) {
    yield put(requestFailed(e));
  }
}

function* removeCourseCategory(action) {
  const token = yield select(tokenSelector);
  const { id } = action;
  try {
    const success = yield call(api.courseCategory.delete, { token, id });
    yield put(removeSucceeded(success));
    yield put(list());
  } catch (e) {
    yield put(requestFailed(e));
  }
}

function* createCourseCategory(action) {
  const token = yield select(tokenSelector);
  const { data } = action;
  try {
    const success = yield call(api.courseCategory.create, { token, data });
    yield put(createSucceeded(success));
    yield put(reset());
    yield put(list());
  } catch (e) {
    yield put(requestFailed(e));
  }
}

export default [
  takeEvery(LIST, listCourseCategories),
  takeEvery(GET, getCourseCategory),
  takeEvery(UPDATE, updateCourseCategory),
  takeEvery(REMOVE, removeCourseCategory),
  takeEvery(CREATE, createCourseCategory),
];
